<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-message" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="chatbot_llmAdd">{{cvbtnAddNew}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="reinitializeChatbot">{{cvReinitializeChatbot}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToTrainChatBot">{{cvbtnTrainBot}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
          <b-col lg="10" xl="10">
            <b-form-input class="form-control"
              @input="searchchatbot_llmWithParams"
              v-model="search_param"
              type="search"
              :placeholder="cvSearchText"></b-form-input>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="chatbot_llmObjList && chatbot_llmObjList.length > 0">
            <b-table
              hover
              responsive
              :items="chatbot_llmObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
              <template v-slot:cell(chatbot_llm_priority)="data">
                {{data.item.chatbot_llm_priority ? data.item.chatbot_llm_priority : '-'}}
              </template>
              <template v-slot:cell(chatbot_llm_api_key)="data">
                {{data.item.chatbot_llm_api_key ? data.item.chatbot_llm_api_key : '-'}}
              </template>
              <template v-slot:cell(chatbot_llm_file_path)="data">
                {{data.item.chatbot_llm_file_path ? data.item.chatbot_llm_file_path : '-'}}
              </template>
              <template v-slot:cell(chatbot_llm_name)="data">
                {{data.item.chatbot_llm_name ? data.item.chatbot_llm_name : '-'}} <br/>
                <b-badge v-if="data.item.deleted === 0" id="badge-success" class="ml-1 mr-1 mb-1" size="sm">
                  ACTIVE
                </b-badge>
                <b-badge v-else id="badge-danger" class="ml-1 mr-1 mb-1" size="sm">
                  INACTIVE
                </b-badge>
              </template>
              <template v-slot:cell(action)="data">
                <b-button :id="data.item.deleted ? 'badge-success' : 'badge-danger'" class="mr-1 mb-1" size="sm" @click="toggleLlmDeletedState(data.item)" :title="data.item.deleted ? 'Activate LLM' : 'Deactivate LLM'">
                  <i class="ri-shut-down-line m-0"></i>
                </b-button>
                <b-button variant="iq-bg-danger mr-1 mb-1" size="sm" @click="showChatBotLLMEditDialog(data.item)" title="Edit LLM"><i class="ri-pencil-line m-0"></i></b-button>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="12" class="my-1">
              <b-row>
                <b-col sm="12" md="7">
                  <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
                </b-col>
                <b-col sm="5" md="5">
                  <b-pagination
                    v-model="currentBatchNo"
                    :total-rows="totalRows"
                    :per-page="dataPerPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelChatBotLLMAdd"
      scrollable
      :title="cvAddModalHeader"
    >
      <ChatBotLLMAdd :propOpenedInModal="true" @emitCloseChatBotLLMAddModal="closeChatBotLLMAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="chatbot_llmAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="showModelChatBotLLMAdd = false">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelChatBotLLMEdit"
      scrollable
      :title="cvEditModalHeader"
    >
      <ChatBotLLMEdit :propOpenedInModal="true" :propChatBotLLMObj="chatbot_llmEditObj" @emitCloseChatBotLLMEditModal="closeChatBotLLMEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="chatbot_llmEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="showModelChatBotLLMEdit = false">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelChatBotLLMDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelChatBotLLMDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="chatbot_llmDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { ChatBotLLMs } from "../../../FackApi/api/ChatBotLLM.js"
import ChatBotLLMAdd from "./ChatBotLLMAdd.vue"
import ChatBotLLMEdit from "./ChatBotLLMEdit.vue"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit.js"
import axios from "axios"

export default {
  name: "ChatBotLLMList",
  components: {
    ChatBotLLMAdd,
    ChatBotLLMEdit
  },
  data () {
    return {
      cvCardTitle: "Chatbot Large Language Models(LLM)",
      cvbtnAddNew: "Add",
      cvReinitializeChatbot: "Reinitialize Chatbot",
      cvbtnTrainBot: "Train Bot",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit ChatBotLLM",
      cvAddModalHeader: "Add ChatBotLLM",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Chat Bot LLM",
      showModelChatBotLLMAdd: false,
      showModelChatBotLLMEdit: false,
      showModelChatBotLLMDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "chatbot llm priority", key: "chatbot_llm_priority", class: "text-left align-text-top", sortable: true },
        { label: "chatbot llm name", key: "chatbot_llm_name", class: "text-left align-text-top", sortable: true },
        { label: "chatbot llm family", key: "chatbot_llm_family", class: "text-left align-text-top", sortable: true },
        { label: "chatbot llm api key", key: "chatbot_llm_api_key", class: "text-left align-text-top", sortable: true },
        { label: "chatbot llm file path", key: "chatbot_llm_file_path", class: "text-left align-text-top", sortable: true },
        { label: "Action ", key: "action", class: "text-left align-text-top", sortable: false }
      ],
      chatbot_llmObjList: [],
      chatbot_llmEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {
      },
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    }
  },
  async mounted () {
    socialvue.index()
    this.chatbot_llmList()
  },
  methods: {
    /**
     * searchchatbot_llmWithParams
     */
    async searchchatbot_llmWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.chatbot_llmList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.chatbot_llmList(true)
    },
    /**
     * chatbot_llmList
     */
    async chatbot_llmList (loadViaLoadMore = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        let chatbotLlmListResp = await ChatBotLLMs.chatbot_llmList(this, this.whereFilter)
        if (chatbotLlmListResp.resp_status) {
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.chatbot_llmObjList = [ ...chatbotLlmListResp.resp_data.data ]
          }
          else {
            this.chatbot_llmObjList = [ ...this.chatbot_llmObjList, ...chatbotLlmListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.chatbot_llmObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.chatbot_llmObjList.length
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo = this.currentBatchNo - 1
          this.toastMsg = chatbotLlmListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbot_llmList() and Exception:", err)
      }
    },
    /**
     * chatbot_llmAdd
     */
    chatbot_llmAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/chatbot_llm_add")
        }
        else {
          this.showModelChatBotLLMAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbot_llmAdd() and Exception:", err.message)
      }
    },
    /**
     * chatbot_llmEdit
     */
    chatbot_llmEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/chatbot_llm_edit/" + this.chatbot_llmEditObj.cbllm_id)
        }
        else {
          this.chatbot_llmEditObj = item
          this.showModelChatBotLLMEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbot_llmEdit() and Exception:", err.message)
      }
    },
    /**
     * showChatBotLLMDeleteDialog
     */
    showChatBotLLMDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelChatBotLLMDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showChatBotLLMDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * showChatBotLLMEditDialog
     */
    showChatBotLLMEditDialog (item) {
      try {
        this.chatbot_llmEditObj = item
        this.showModelChatBotLLMEdit = true
      }
      catch (err) {
        console.error("Exception occurred at showChatBotLLMEditDialog() and Exception:", err.message)
      }
    },
    /**
     * chatbot_llmDelete
     */
    async chatbot_llmDelete () {
      try {
        let chatbotLlmDelResp = await ChatBotLLMs.chatbot_llmDelete(this, this.delObj.cbllm_id)
        await ApiResponse.responseMessageDisplay(this, chatbotLlmDelResp)

        if (chatbotLlmDelResp && !chatbotLlmDelResp) {
          this.showModelChatBotLLMDelete = false
          return false
        }

        let index = this.chatbot_llmObjList.indexOf(this.delObj)
        this.chatbot_llmObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelChatBotLLMDelete = false
      }
      catch (err) {
        console.error("Exception occurred at chatbot_llmDelete() and Exception:", err.message)
      }
    },
    /**
     * closeChatBotLLMAddModal
     */
    closeChatBotLLMAddModal (chatbotLlmAddData) {
      try {
        this.chatbot_llmList()
        this.showModelChatBotLLMAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closechatbot_llmAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeChatBotLLMEditModal
     */
    closeChatBotLLMEditModal () {
      try {
        this.chatbot_llmList()
        this.showModelChatBotLLMEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeChatBotLLMEditModal() and Exception:", err.message)
      }
    },
    /**
     * goToTrainChatBot
    */
    goToTrainChatBot () {
      this.$router.push("/chatbot_data_src_list")
    },
    /**
     * toggleLlmDeletedState
     */
    async toggleLlmDeletedState (chatbotLlmObj) {
      try {
        let payload = {
          cbllm_id: chatbotLlmObj.cbllm_id
        }

        if (chatbotLlmObj.deleted === 1) {
          payload.deleted = 0
        }
        else {
          payload.deleted = 1
        }
        const activationResp = await ChatBotLLMs.chatbot_llm_toggle_deleted_state(this, payload)
        await ApiResponse.responseMessageDisplay(this, activationResp)
        if (activationResp.resp_status) {
          this.chatbot_llmList()
        }
      }
      catch (err) {
        console.log("Exception in toggleLlmDeletedState and err: ", err)
      }
    },
    /**
     * reinitializeChatbot
     * Call the switch_llm API in the chatbot service to reinitialize the LLM engine
     */
    async reinitializeChatbot () {
      try {
        const resp = await axios.post(`${process.env.VUE_APP_CHATBOT_SERVICE}/switch_llm`)
        this.showToast = true
        this.toastMsg = "Chatbot reinitialized successfully."
        this.toastVariant = "success"
        this.toastTitle = "Success"
        console.log("LLM switched successfully:", resp.data)
      }
      catch (err) {
        this.showToast = true
        this.toastMsg = "Error in reinitializing Chatbot."
        this.toastVariant = "danger"
        this.toastTitle = "Error"

        console.error("Error in switching LLM:", err.message)
      }
    }
  }
}
</script>
<style scoped>
#badge-success {
    color: #fff;
    background-color: #28a745 !important;
}
#badge-danger {
    color: #fff;
    background-color: #dc3545 !important;
}
</style>
